module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remotePayDone"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('remoteDone.crumbs.L1')))]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/main/remotePay'
      },
      "replace": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('remoteDone.crumbs.L2')))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('remoteDone.crumbs.L3')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.$t('remoteDone.panel.title')))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body fe-panel_body"
  }, [_c('span', {
    staticClass: "pay-title"
  }, [_vm._v(_vm._s(_vm.$t('remoteDone.msg.title')))]), _vm._v(" "), _c('span', {
    staticClass: "links"
  }, [_vm._v(_vm._s(_vm.link_url))]), _vm._v(" "), _c('el-button', {
    staticClass: "copy_content",
    on: {
      "click": function($event) {
        return _vm.handleClipboard(_vm.link_url, $event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('remoteDone.msg.copy')))]), _vm._v(" "), _c('el-button', {
    staticClass: "send-color",
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('remoteDone.msg.send')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.$t('remoteDone.transaction.title')))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body table-panel_body"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.formData
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('remoteDone.table.productName'),
      "prop": "goods_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('remoteDone.table.quantity'),
      "prop": "quantity"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('remoteDone.table.currency'),
      "prop": "currency"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.current[scope.row.currency]) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('remoteDone.table.price'),
      "prop": "unit_price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('remoteDone.table.totalAmount'),
      "prop": "total_price"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.current[_vm.form.totalCurrency]) + " " + _vm._s(scope.row.total_price) + "\n          ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-info"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.$t('remoteDone.table.totalAmount')))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.current[_vm.form.totalCurrency]) + " " + _vm._s(_vm.form.totalAmount))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.$t('remoteDone.table.customerName')))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.form.customerName))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.$t('remoteDone.table.customerPhone')))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.form.customerPhone))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.$t('remoteDone.table.customerEmail')))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.form.customerEmail))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.$t('remoteDone.table.paymentDeadline')))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.form.paymentDeadline))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.$t('remoteDone.table.logisticsMode')))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.logisticsModeList[_vm.form.logisticsMode]))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.$t('remoteDone.table.date')))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.form.date))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.$t('remoteDone.table.description')))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.form.description))])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialogTitle",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('remoteDone.msg.send')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialogContent"
  }, [_c('div', {
    staticClass: "shareEmail"
  }, [_c('img', {
    attrs: {
      "src": require("./share_email.svg"),
      "alt": ""
    },
    on: {
      "click": _vm.shareEail
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('remoteDone.msg.Email')))])]), _vm._v(" "), _c('div', {
    staticClass: "shareLink"
  }, [_c('img', {
    attrs: {
      "src": require("./share_copy_link.svg"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleClipboard(_vm.link_url, $event)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('remoteDone.msg.copyLink')))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-8c91b35c"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/remotepayDone/remotePayDone.vue
// module id = 927
// module chunks = 0